<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalPettyCash v-if="modalShowPettyCash" @closeModal="closeModal" :petty_cash="selectedPettyCash"
    :current-cash="currentTotalAmountCashRegisterOpen" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Pengeluaran" />
      <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg">
        <DetailComponent title="Cash Register" caption="Cash register saat ini" :items="summaryCashRegister" />
        <div id="table-header" class="mb-5 flex justify-between">
          <AddButton to_url="#" button_text="+ Tambah Pengeluaran" button_class="text-base py-2 font-medium"
            @click="showModal" />
        </div>
        <div class="flex items-end gap-4 mb-5">
          <div class="flex">
            <InputSelect v-model="selectedCashRegisterId" label="Filter Cash Register" id="filter-cash-register"
              :options="optionCashRegister" placeholder="Pilih cash register" optionLabel="name" optionValue="id" />
          </div>
          <!-- Single Dropdown Menu -->
          <div class="relative inline-block text-left">
            <button type="button" @click="toggleDropdown"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
              id="menu-button" aria-expanded="true" aria-haspopup="true">
              Print Laporan
              <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                aria-hidden="true">
                <path fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd" />
              </svg>
            </button>

            <!-- Dropdown items -->
            <div v-show="isDropdownOpen"
              class="origin-top-left absolute left-0 mt-2 w-80 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
              role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
              <div class="py-1" role="none">
                <button @click="printPettyCashReport"
                  class="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" role="menuitem"
                  tabindex="-1">
                  Print Laporan ke Printer Thermal
                </button>
                <button @click="printPettyCashPdf"
                  class="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" role="menuitem"
                  tabindex="-1">
                  Print Laporan PDF
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="inline-block min-w-full align-middle">
          <div class="inline-block min-w-full align-middle mt-5">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Deskripsi</TableHeadCell>
                    <TableHeadCell>Withdraw</TableHeadCell>
                    <TableHeadCell>Deposit</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Dibuat Tanggal</TableHeadCell>
                    <TableHeadCell>Cash Register</TableHeadCell>
                    <!-- <TableHeadCell>Action</TableHeadCell> -->
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="filteredPettyCashes?.length == 0">
                    <TableCell colspan="5" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(petty_cash, index) in filteredPettyCashes" :key="petty_cash.id"
                    :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ petty_cash.description }}</TableCell>
                    <TableCell>{{ formatRupiah(petty_cash.amount_withdrawal) }}</TableCell>
                    <TableCell>{{ formatRupiah(petty_cash.amount_deposit) }}</TableCell>
                    <TableCell>{{ petty_cash.status }}</TableCell>
                    <TableCell>{{ formatTime(petty_cash.createdAt) }}</TableCell>
                    <TableCell>{{ formatTime(petty_cash.cash_register?.time_start) }}</TableCell>
                    <!-- <TableCell noTextColor customClass="text-gray-500 dark:text-gray-400 flex">
                      <button :id="'edit-data-' + petty_cash.id" @click="editExpenditure(expenditure)"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <PencilSquareIcon class="h-4 w-4 group-hover:text-green-700" />
                      </button>
                      <button :id="'delete-data-' + petty_cash.id" @click="deleteExpenditure(expenditure)"
                        class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                      </button>
                    </TableCell> -->
                  </TableRow>
                </TableBody>
              </TableComponent>
              <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
  import IndexView from "@/views/IndexView.vue";
  import PageTitle from "@/components/PageTitle.vue";
  import AddButton from "@/components/buttons/AddButton.vue";
  import ViewContainer from "@/components/ViewContainer.vue";
  import {
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
  } from "@/components/table";
  import PaginationButtons from "@/components/PaginationButtons.vue";
  import { Button, ConfirmDialog, Toast } from "primevue";
  import ModalPettyCash from "./modals/ModalPettyCash.vue";
  import { mapGetters } from "vuex";
  import { formatRupiah } from "@/helpers/formatRupiah";
  import { formatDate, formateISODate, formatTime } from "@/helpers/formatTime";
  import DetailComponent from "../new-transaction/DetailComponent.vue";
  import InputSelect from "@/components/form/InputSelect.vue";
  import _ from 'lodash';
  import axios from "axios";
  import print from "@/helpers/print";
  import printPdf from "@/helpers/printPdf";

  export default {
    name: "PettyCashView",
    components: {
      IndexView, PageTitle, AddButton, ViewContainer, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell, PaginationButtons, ConfirmDialog, Button, Toast, ModalPettyCash, DetailComponent, InputSelect
    },
    data() {
      return {
        modalShowPettyCash: false,
        isBlur: false,
        selectedPettyCash: null,
        currentPage: 1,
        totalPages: 1,
        selectedCashRegisterId: null,
        isDropdownOpen: false,
      }
    },
    computed: {
      ...mapGetters('petty_cash', ['allPettyCashes']),
      ...mapGetters('cash_registers', ['allCashRegisters']),
      filteredPettyCashes() {
        this.allPettyCashes.map(pc => {
          pc.cash_register = this.allCashRegisters.find(cr => cr.id == pc.cash_register_id);
          return pc;
        });
        return this.allPettyCashes;
      },
      openCashRegister() {
        return this.allCashRegisters.find(cr => cr.status == 'open');
      },
      optionCashRegister() {
        const option = this.allCashRegisters.map((cashRegister) => {
          return {
            name: `${formatTime(cashRegister.time_start)} - ${formatTime(cashRegister.time_end)}`,
            id: cashRegister.id,
          };
        });
        option.unshift({
          name: 'Semua Cash Register',
          id: null,
        });
        return option;
      },
      currentTotalAmountCashRegisterOpen() {
        let amountCashRegisterOpen = this.openCashRegister ? this.openCashRegister?.orders.reduce((sum, item) => sum + (item.status == 'paid' && item?.payment_method?.is_cash_register ? parseFloat(item.grand_total) : 0), 0) : 0;
        let amountPettyCashOpen = this.openCashRegister ? this.allPettyCashes.reduce((sum, pc) => sum + (this.openCashRegister.id == pc.cash_register_id ? parseFloat(pc.amount_deposit ? pc.amount_deposit : 0) + parseFloat(pc.amount_withdrawal ? pc.amount_withdrawal * (-1) : 0) : 0), 0) : 0;
        console.log("amountCashRegisterOpen", amountCashRegisterOpen);
        console.log("amountPettyCashOpen", amountPettyCashOpen);
        return parseFloat(this.openCashRegister ? this.openCashRegister?.start_saldo : 0) + amountCashRegisterOpen + amountPettyCashOpen;
      },
      cashIn() {
        return this.allPettyCashes.reduce((sum, pc) => sum + (this.openCashRegister?.id == pc.cash_register_id ? parseFloat(pc.amount_deposit ? pc.amount_deposit : 0) : 0), 0);
      },
      cashOut() {
        return this.allPettyCashes.reduce((sum, pc) => sum + (this.openCashRegister?.id == pc.cash_register_id ? parseFloat(pc.amount_withdrawal ? pc.amount_withdrawal * (-1) : 0) : 0), 0);
      },
      salesCash() {
        return this.allCashRegisters?.filter(cr => this.selectedCashRegisterId ? (cr.id == this.selectedCashRegisterId) : true)?.reduce((sum, cr) => sum + (cr.orders.reduce((sum, item) => sum + (item.status == 'paid' && item?.payment_method?.is_cash_register ? parseFloat(item.grand_total) : 0), 0)), 0);
      },
      totalStartSaldo() {
        return this.allCashRegisters?.filter(cr => this.selectedCashRegisterId ? (cr.id == this.selectedCashRegisterId) : true)?.reduce((sum, cr) => sum + Number(cr.start_saldo), 0);
      },
      totalEndSaldo() {
        return this.allCashRegisters?.filter(cr => this.selectedCashRegisterId ? (cr.id == this.selectedCashRegisterId) : true)?.reduce((sum, cr) => sum + Number(cr.end_saldo), 0);
      },
      deviation() {
        return this.salesCash + this.cashIn + this.totalStartSaldo + this.cashOut;
      },
      summaryCashRegister() {
        return [
          { field: 'Total Kas Cash Register Saat ini : ', value: this.currentTotalAmountCashRegisterOpen, type: 'rupiah' },
          { field: 'Total Saldo Awal : ', value: this.totalStartSaldo, type: 'rupiah' },
          { field: 'Total Saldo Akhir : ', value: this.totalEndSaldo, type: 'rupiah' },
          { field: 'Total Kas Masuk : ', value: this.cashIn, type: 'rupiah' },
          { field: 'Total Kas Keluar : ', value: this.cashOut, type: 'rupiah' },
          { field: 'Total Penjualan : ', value: this.salesCash, type: 'rupiah' },
          { field: 'Total Kas : ', value: this.deviation, type: 'rupiah' },
        ];
      },
    },
    async created() {
      await this.$store.dispatch('petty_cash/fetchPettyCashes', { page: 1, limit: 50 });
      await this.$store.dispatch('cash_registers/fetchCashRegisters', { page: 1, limit: 5000 });
      this.selectedCashRegisterId = this.openCashRegister ? this.openCashRegister.id : null;
    },
    watch: {
      currentPage: {
        immediate: true,
        handler(newVal) {
          this.fetchPettyCashes({ page: newVal });
        },
      },
      selectedCashRegisterId: {
        immediate: true,
        handler: _.debounce(function (newVal) {
          this.fetchPettyCashes({ page: 1, cash_register_id: newVal ? newVal : null });
        }, 1500) // 500ms delay after user stops selecting
      },
    },
    methods: {
      formatRupiah,
      formatTime,
      toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
      },
      async fetchPettyCashes(params = {}) {
        if (!params.page) params.page = this.currentPage;
        if (!params.limit) params.limit = 50;
        if (!params.cash_register_id) params.cash_register_id = this.cashRegisterId;
        try {
          const { pagination } = await this.$store.dispatch('petty_cash/fetchPettyCashes', params);
          if (pagination) {
            this.totalPages = pagination.totalPages;
          }
        } catch (error) {
          console.log(error);
        }
        await this.$store.dispatch('cash_registers/fetchCashRegisters');
      },
      showModal() {
        this.modalShowPettyCash = true;
        this.isBlur = true;
        this.selectedPettyCash = null;
      },
      closeModal() {
        setTimeout(() => {
          this.modalShowPettyCash = false;
          this.isBlur = false;
          this.fetchPettyCashes();
        }, 200);
      },
      editPettyCash(petty_cash) {
        this.selectedPettyCash = petty_cash;
        this.modalShowPettyCash = true;
        this.isBlur = true;
      },
      async deletePettyCash(petty_cash) {
        this.$confirm.require({
          group: 'headless',
          header: 'Apakah anda yakin ingin menghapus pengeluaran ini?',
          message: 'Silahkan konfirmasi sebelum diproses.',
          acceptLabel: 'Ya',
          rejectLabel: 'Tidak',
          accept: async () => {
            try {
              const response = await this.deletePettyCashById(petty_cash.id);
              console.log('response', response);
              this.fetchPettyCashes();
              this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus pengeluaran.', life: 3000 });
            }
            catch (error) {
              console.error('Gagal menghapus pengeluaran.', error);
              this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus pengeluaran.', life: 3000 });
            }
          },
          reject: () => {
            this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus pengeluaran.', life: 3000 });
          }
        });
      },
      async formatReportPrint() {
        let params = {};
        if (this.selectedCashRegisterId) {
          params.cash_register_id = this.selectedCashRegisterId;
        }
        try {
          let printerText = ``;
          const rows = [];

          // Add company header with center alignment
          rows.push("\x1b\x61\x01"); // Center alignment
          rows.push(process.env.VUE_APP_STORE_NAME);
          rows.push(process.env.VUE_APP_STORE_ADDRESS);
          rows.push(process.env.VUE_APP_STORE_PHONE);
          rows.push(print.breakLine(40, " "));
          rows.push("PERGERAKAN KAS KECIL");

          const response = await this.$store.dispatch('petty_cash/fetchPettyCashes', { ...params, limit: null });

          const pettyCash = response?.data || null;

          if (!pettyCash) {
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal mengambil data pengeluaran.', life: 3000 });
            return null;
          }

          const cashRegisterSelected = this.allCashRegisters?.find(cr => cr.id == this.selectedCashRegisterId);
          rows.push(print.twoColumn(`Date Work`, `${cashRegisterSelected ? this.formatTime(cashRegisterSelected?.time_start) : 'ALL'}`, 10, 6, 24));
          rows.push(print.breakLine(40, " "));

          const columns = [
            { header: 'TIME', key: 'time', width: 6, align: 'left' },
            { header: 'CODE', key: 'code', width: 5, align: 'left' },
            { header: 'TOTAL', key: 'total', width: 13, align: 'left' },
            { header: 'CATATAN', key: 'note', width: 10, align: 'left' }
          ];

          const createdDate = new Date(cashRegisterSelected ? cashRegisterSelected?.time_start : new Date());
          const timeString = createdDate.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          });

          const totalStartSaldo = cashRegisterSelected ? Number(cashRegisterSelected?.start_saldo) : this.totalStartSaldo;

          let records = [];
          records.push({
            time: timeString,
            code: 'IN',
            total: Number(totalStartSaldo).toLocaleString('id-ID'),
            note: 'Saldo Awal'
          });
          pettyCash?.forEach(pc => {
            const createdDate = new Date(pc.createdAt);
            const timeString = createdDate.toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false
            });
            records.push({
              time: timeString,
              code: pc.status === 'deposit' ? 'IN' : 'OUT',
              total: pc.status === 'deposit' ? this.formatRupiah(parseFloat(pc.amount_deposit)) : this.formatRupiah(parseFloat(pc.amount_withdrawal)),
              note: pc.note
            });
          });
          const table = print.tablePrint(columns, records, { spacing: 1 });
          rows.push(table);
          rows.push(print.breakLine(40, "-"));

          const cashIn = pettyCash?.filter(pc => pc.status === 'deposit').reduce((sum, pc) => sum + Number(pc.amount_deposit), 0);
          const cashOut = pettyCash?.filter(pc => pc.status === 'withdrawal').reduce((sum, pc) => sum + Number(pc.amount_withdrawal), 0);
          const salesCash = this.allCashRegisters?.filter(cr => this.selectedCashRegisterId ? (cr.id == this.selectedCashRegisterId) : true)?.reduce((sum, cr) => sum + (cr.orders.reduce((sum, item) => sum + (item.status == 'paid' && item?.payment_method?.is_cash_register ? parseFloat(item.grand_total) : 0), 0)), 0);
          const deviation = salesCash + cashIn - cashOut + Number(totalStartSaldo);

          rows.push(print.breakLine(40, " "));
          rows.push(print.twoColumn(`CASH IN`, this.formatRupiah(cashIn), 10, 6, 24));
          rows.push(print.twoColumn(`SALES CASH`, this.formatRupiah(salesCash), 10, 6, 24));
          rows.push(print.twoColumn(`TOTAL`, this.formatRupiah(cashIn + salesCash), 10, 6, 24));
          rows.push(print.breakLine(40, " "));
          rows.push(print.twoColumn(`CASH OUT`, this.formatRupiah(cashOut), 10, 6, 24));
          rows.push(print.twoColumn(`DEVIATION`, this.formatRupiah(deviation), 10, 6, 24));

          rows.push(print.breakLine(40, " "));
          rows.push(`Jam Cetak: \t ${new Date().toLocaleString()}`);
          rows.push("\n"); // Extra lines for paper cut
          printerText = rows.join("\n");
          return printerText;
        } catch (error) {
          console.log(error);
        }
        await this.$store.dispatch('cash_registers/fetchCashRegisters');
      },
      async printPettyCashReport() {
        try {

          // Convert the element to text format suitable for ESC/POS
          const printText = await this.formatReportPrint();
          console.log("printText:", printText);

          // Send to backend printer endpoints
          const print_url =
            process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";

          const response = await axios.post(print_url, {
            text: printText,
            printer_ip: process.env.VUE_APP_CASIER_IP,
          });

          // Optional: Show success message
          console.log("Print job sent successfully", response);
        } catch (error) {
          console.error("Print error:", error);
          this.errorMessage = "Failed to print: " + error.message;
          this.showErrorDialog = true;
        }
      },
      async printPettyCashPdf() {
        try {
          let params = {};
          if (this.selectedCashRegisterId) {
            params.cash_register_id = this.selectedCashRegisterId;
          }

          const data = await this.$store.dispatch('petty_cash/fetchPettyCashes', { ...params, limit: null });
          const cashRegister = this.allCashRegisters?.find(cr => cr.id == this.selectedCashRegisterId)
          let saldo = Number(cashRegister?.start_saldo || 0);
          let reportData = [{
            no: 1,
            due_date: formatDate(cashRegister?.createdAt),
            category: 'IN',
            amount_deposit: saldo,
            amount_withdrawal: 0,
            saldo: this.formatRupiah(saldo),
            description: 'Modal Awal',
          }];
          reportData.push(...data?.data?.map(
            (item, index) => {
              saldo += Number(item?.amount_deposit || 0) - Number(item?.amount_withdrawal || 0);
              console.log("saldo", saldo);
              return {
                no: index + 2,
                due_date: formatDate(item?.createdAt),
                category: item.status === 'deposit' ? 'IN' : 'OUT',
                amount_deposit: this.formatRupiah(Number(item?.amount_deposit || 0)),
                amount_withdrawal: this.formatRupiah(Number(item?.amount_withdrawal || 0)),
                saldo: this.formatRupiah(saldo),
                description: item.transaction_date,
              }
            })
          );
          const tableHeader = [
            { header: 'No', dataKey: 'no' },
            { header: 'Waktu', dataKey: 'due_date' },
            { header: 'Kategori', dataKey: 'category' },
            { header: 'IN', dataKey: 'amount_deposit' },
            { header: 'OUT', dataKey: 'amount_withdrawal' },
            { header: 'Saldo', dataKey: 'saldo' },
            { header: 'Deskripsi', dataKey: 'description' }
          ];

          const inTotal = data?.data?.reduce((total, item) => total + Number(item?.amount_deposit || 0), 0) + Number(cashRegister?.start_saldo || 0);
          const outTotal = data?.data?.reduce((total, item) => total + Number(item?.amount_withdrawal || 0), 0);

          const summary = [
            { label: 'CASH IN', value: this.formatRupiah(inTotal) },
            { label: 'SALES CASH', value: this.formatRupiah(this.salesCash) },
            { label: 'CASH IN + SALES CASH', value: this.formatRupiah(inTotal + this.salesCash) },
            { label: '', value: this.formatRupiah(inTotal + this.salesCash) },
            { label: 'CASH OUT', value: this.formatRupiah(outTotal) },
            { label: 'DEVIATION', value: this.formatRupiah(inTotal + this.salesCash - outTotal) }
          ];

          console.log("reportData", reportData);
          console.log("summary", summary);

          const tableColumnStyle = {
            0: { cellWidth: 6 },   // No
            1: { cellWidth: 25 },  // Waktu
            2: { cellWidth: 25, halign: 'right' },  // IN
            3: { cellWidth: 25, halign: 'right' },  // OUT
            4: { cellWidth: 25, halign: 'right' },  // Saldo
            5: { cellWidth: 25, halign: 'center' }  // Deskripsi
          };

          printPdf.generateAccountsReceivableReport(
            {
              tableHeader,
              reportData,
              summary,
              tableColumnStyle
            },
            {
              title: 'LAPORAN PETTY CASH',
              companyName: process.env.VUE_APP_STORE_NAME || 'Xixi Lounge & KTV',
              companyAddress: process.env.VUE_APP_STORE_ADDRESS || 'Jl. Tidar No. 350',
              startDate: cashRegister ? formateISODate(cashRegister?.time_start) : '-', // Set your start date
              endDate: cashRegister ? formateISODate(cashRegister?.time_end) : '-', // Current date
              fontSizeTable: 6
            }
          );
        } catch (error) {
          console.error('Gagal mencetak tagihan.', error);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal mencetak tagihan.', life: 3000 });
        }
      }
    },
  }
</script>